import React, { FC } from "react";
import {
  Switch,
  FormControl,
  FormLabel,
  FormControlLabel,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import useEqualPanelsSelector from "./useEqualPanelsSelector";

const StyledDiv = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  width: "95%",
});

const StyledFormControl = styled(FormControl)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
});

interface EqualPanelsProp {
  isPivot?: boolean;
}

const EqualPanels: FC<EqualPanelsProp> = ({ isPivot = false }) => {
  const { handleChange, checked } = useEqualPanelsSelector(isPivot);

  return (
    <StyledDiv>
      <StyledFormControl variant="standard">
        <FormLabel style={{ color: "black" }}>
          <span style={{ fontWeight: "bold" }}>Optional:</span> Make Panel and
          Sidelite Widths Equal Size
        </FormLabel>
        <FormControlLabel
          control={
            <Switch color="primary" onChange={handleChange} checked={checked} />
          }
          label={checked ? "Yes" : "No"}
        />
      </StyledFormControl>
    </StyledDiv>
  );
};

export default EqualPanels;
